let Testimonial = [
  {
    id: "0",
    image: "images/man1.jpg",
    description:
      "I highly recommend shiblu for any web development and design projects. Their attention to detail and creativity exceeded my expectations. ",
    name: "Ziaul haque",
    title: "Co-founder Td",
  },
  {
    id: "1",
    image: "images/man3.jpg",
    description:
      "Working with Shiblu on my website was a seamless experience. They were able to bring my vision to life and deliver a finished product that exceeded my expectations ",
    name: "Hasanul Haque",
    title: "Founder TD",
  },
  {
    id: "2",
    image: "images/woman1.jpg",
    description:
      "I was impressed by Shiblu's ability to understand my business needs and tailor the website accordingly. They truly understand the importance of user experience.",
    name: "Sadia Nowshin",
    title: "Student",
  },
  {
    id: "3",
    image: "images/man4.jpg",
    description:
      "The team at Shiblu is professional, knowledgeable, and efficient. They were able to complete my website on time and within budget. ",
    name: "Nahid alam",
    title: "Student",
  },
  {
    id: "4",
    image: "images/woman2.jpg",
    description:
      "I was impressed by Shiblu's understanding of the latest web development and design trends. They were able to incorporate them into my website and give it a modern and professional look.",
    name: "Jakia Sultana ",
    title: "Student",
  },
  {
    id: "5",
    image: "images/man2.jpg",
    description:
      "I have been extremely pleased with the results of my website, thanks to the work of Shiblu. They were able to effectively communicate and collaborate with me throughout the entire process.",
    name: "Hasan mahmud",
    title: "Business man",
  },
  {
    id: "6",
    image: "images/woman3.jpg",
    description:
      "I highly recommend Shiblu for any web development and design projects. They are a pleasure to work with and deliver exceptional results.",
    name: "Sadika Mahbuba",
    title: "Student",
  },
];
export default Testimonial;
